import React, { useState } from 'react'
import useSWR from 'swr'
import { withTranslation } from 'react-i18next'
import { filterValues } from 'Helper'
import Select from 'react-select'

export default withTranslation()(function AssignRoleModal({ t, user, loading, onCancel, onConfirm }) {
  const { data: rolesRes } = useSWR('user-mgmt/roles')
  const roles = rolesRes?.data ?? []
  const roleOptions = filterValues({ options: roles, param: { value: 'id', label: 'display_name' } })

  const [roleId, setRoleId] = useState(user?.roles?.[0]?.id ?? '')
  const selected = roleOptions.find((option) => `${option.value}` === `${roleId}`) ?? null

  return (
    <div className="fixed inset-0 z-[5000] bg-black bg-opacity-30 flex items-center justify-center p-4" onClick={onCancel}>
      <div className="bg-white relative w-11/12 max-w-sm max-h-[90vh] rounded-2xl flex flex-col overflow-hidden" onClick={(event) => event.stopPropagation()}>
        <h3 className="text-lg font-bold text-dark-blue text-center shrink-0 pt-6 px-6 md:pt-8 md:px-8 mb-6">
          {t('settings.user_management.assign_role_modal.title')}
        </h3>

        <div className="overflow-y-auto px-6 pb-6 md:px-8 md:pb-8">
          <div className="mb-6">
            <label className="block text-sm text-secondary mb-1.5">
              {t('settings.user_management.assign_role_modal.current_role')}
            </label>

            <Select
              value={selected}
              onChange={(option) => setRoleId(option?.value ?? '')}
              options={roleOptions}
              classNamePrefix="react-select"
            />
          </div>

          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={onCancel}
              className="flex-1 h-11 rounded-full border border-border-lines text-dark-blue font-medium"
            >
              {t('misc.cancel')}
            </button>

            <button
              type="button"
              onClick={() => onConfirm(roleId)}
              disabled={!roleId || loading}
              className="flex-1 h-11 rounded-full bg-primary text-white font-medium disabled:opacity-50"
            >
              {t('settings.user_management.assign_role')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
})
